<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-header-title">
      {{ headerTitle }}
    </div>
    <div class="dialog-header-cross" (click)="cancelClicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>
  <div class="dialog-form">
    <div class="confirm-class">
      <ng-container *ngIf="!codeInputScreen">
        <p class="label-title">
          {{ selectorText }}
        </p>
        <ng-container *ngIf="listOfDiscounts.length; else emptyContainer">
          <div class="discount-card-grid">
            <div
              class="discount-card flex-center"
              *ngFor="let item of listOfDiscounts"
              [ngClass]="
                selectedVoucherTitle === item?.title
                  ? 'discount-card-selected'
                  : null
              "
              (click)="voucherTitleClicked(item?.title)"
            >
              {{ item?.title }}
            </div>
          </div>
        </ng-container>
        <ng-template #emptyContainer>
          <nz-empty></nz-empty>
        </ng-template>
      </ng-container>
      <form
        *ngIf="codeInputScreen"
        nz-form
        nzLayout="vertical"
        [formGroup]="validateForm"
        [nzLayout]="'vertical'"
      >
        <nz-form-item>
          <nz-form-label [nzSm]="12" [nzXs]="24" nzFor="code" nzRequired>
            {{ selectorText }}
          </nz-form-label>
          <nz-form-control
            [nzSpan]="24"
            [nzValidateStatus]="voucherValidity?.status"
            nzHasFeedback
          >
            <input
              nz-input
              nzSize="large"
              placeholder="{{ 'ENTER_CODE_HERE' | fallbackTranslate }}"
              formControlName="code"
              id="code"
              required
            />
            <!-- <ng-template #combineError let-control>
                <ng-container *ngIf="control.hasError('required')">field is required</ng-container>
              </ng-template> -->

            <div class="error-field ant-form-explain">
              <p
                style="color: #e3502d"
                *ngIf="validateForm.get('code').hasError('required')"
              >
                {{ 'FIELD_IS_REQ' | fallbackTranslate }}
              </p>
              <p
                style="color: #e3502d"
                *ngIf="
                  !(
                    voucherValidity?.statusCode === null ||
                    voucherValidity?.statusCode === 201
                  )
                "
              >
                {{ voucherValidity?.message }}
              </p>
              <p
                style="color: #73c61b"
                *ngIf="voucherValidity?.statusCode === 201"
              >
                {{ voucherValidity?.message }}
              </p>
            </div>
          </nz-form-control>
        </nz-form-item>
      </form>
    </div>
  </div>
  <div class="flex dialog-footer">
    <ng-container *ngIf="!codeInputScreen">
      <button
        nz-button
        nzType="primary"
        nzSize="large"
        [nzLoading]="isLoading"
        (click)="onNextClick()"
        class="success-btn wd-100"
        [disabled]="!selectedVoucherTitle"
      >
        {{ 'NEXT' | fallbackTranslate }}
      </button>
    </ng-container>
    <ng-container *ngIf="codeInputScreen">
      <button
        class="wd-50 m-r-10"
        nz-button
        nzType="danger"
        nzSize="large"
        (click)="onBackClick()"
      >
        {{ 'BACK' | fallbackTranslate }}
      </button>
      <button
        class="success-btn wd-50"
        nz-button
        nzType="primary"
        nzSize="large"
        [nzLoading]="isLoading"
        (click)="onApplyClicked()"
      >
        {{ 'APPLY' | fallbackTranslate }}
      </button>
    </ng-container>
  </div>
</div>
